import React, { Component } from 'react';
import ReactDOM from 'react-dom';

import './ImagePortal.scss';

const modalRoot = document.getElementById('modal-root');

class ImagePortal extends Component {
  constructor(props) {
    super(props);

    this.el = document.createElement('div');
  }

  componentDidMount() {
    modalRoot.appendChild(this.el);
  }

  componentWillUnmount() {
    modalRoot.removeChild(this.el);
  }

  render() {
    return ReactDOM.createPortal(
      <div className="modal">
        {this.props.children}
      </div>,
      this.el,
    );
  }
}

export default ImagePortal;